import type { Page as PageType } from 'src/types/page';
import { ServicePage } from 'src/sections/services/service-page';

const Page: PageType = () => (
  <ServicePage
    seoTitle="Web Design & Development | Mystic Media Film"
    seoDescription="Custom Houston web design and development from Mystic Media Film. Conversion-focused sites built without templates, with SEO and performance baked in."
    service="Websites"
    eyebrow="Websites — 2026"
    headline="Websites that"
    accent="convert."
    sub="Fast, modern sites built to look sharp, load quick, and grow with your business."
    description="Custom-built websites — design, copy, and code from one team. |No templates, no tech debt. Performance and SEO baked in from day one."
    deliverables={[
      { num: '01', title: 'Design', body: 'Custom layouts tailored to your brand — no templates.' },
      { num: '02', title: 'Development', body: 'Hand-coded builds on modern frameworks for speed and stability.' },
      { num: '03', title: 'CMS Setup', body: 'A friendly editor so your team can update content without breaking anything.' },
      { num: '04', title: 'Performance', body: 'Lighthouse 90+ scores and Core Web Vitals in the green.' },
      { num: '05', title: 'SEO Foundation', body: 'Schema, metadata, sitemap, and content structured for search.' },
      { num: '06', title: 'Launch & Support', body: 'Hosting, analytics, and ongoing care plans available.' }
    ]}
    outcomes={['Fast', 'Secure', 'SEO-ready', 'Editable']}
    process={[
      { num: '01', title: 'Discovery', body: 'We map your audience, goals, and competitors — then turn it into a site plan.' },
      { num: '02', title: 'Design', body: 'Wireframes and visual direction, refined with you in real time.' },
      { num: '03', title: 'Build', body: 'Hand-coded development with weekly check-ins and a staging URL from day one.' },
      { num: '04', title: 'Launch', body: 'QA, deploy, train your team, and stay on for post-launch support.' }
    ]}
    whyUs={[
      { title: 'Hand-coded, not templated', body: 'Every site is built from scratch on modern frameworks — no page-builder bloat dragging down your speed.' },
      { title: 'Performance is the default', body: 'Lighthouse 90+, Core Web Vitals green, and image optimization shipped on day one — not as an upsell.' },
      { title: 'One team, end to end', body: 'Strategy, design, copy, and code under one roof. No agency-of-record finger-pointing when something needs to change.' }
    ]}
    faqs={[
      { q: 'How long does a typical site take?', a: 'Most projects ship in 4–8 weeks depending on scope and content readiness. We share a timeline up front and stick to it.' },
      { q: 'Do you offer hosting?', a: 'Yes — we manage hosting, SSL, backups, uptime monitoring, and ongoing care plans so your site is never an afterthought.' },
      { q: 'Can my team edit content?', a: 'Every site ships with a friendly CMS your team can use without breaking layout or design. We train your team during handoff.' },
      { q: 'What about SEO?', a: 'Schema, metadata, sitemap, semantic HTML, and content structure are baked in. We also set up analytics and Search Console at launch.' },
      { q: 'Do you do redesigns?', a: 'Yes. We start with an audit of your current site, then chart the migration path — including SEO continuity and 301 redirects.' },
      { q: 'What if we need changes after launch?', a: 'We offer monthly care plans for updates, copy changes, and new sections — or you can book us project-by-project.' }
    ]}
  />
);

export default Page;
